import {
	ChangeDetectionStrategy,
	Component,
	computed,
	effect,
	input,
	OnDestroy,
} from '@angular/core';
import { ClearingService, replaceDashWithSpace, SeoMetadataService } from '@uc/utilities';
import { SearchSvgComponent, StatementsBookmarkComponent } from '@uc/shared/svg';
import { RouterLink } from '@angular/router';
import { CLEARING_DISABLED_COPY } from '../../../static/clearing-course-search.properties';
import {
	formatClearingDisabledDesc,
	formatClearingTitle,
} from '../../../utils/clearing.utils';

@Component({
	selector: 'uc-clearing-courses-empty-state',
	standalone: true,
	imports: [RouterLink, SearchSvgComponent, StatementsBookmarkComponent],
	templateUrl: './clearing-courses-empty-state.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearingCoursesEmptyStateComponent implements OnDestroy {
	subject = input.required<string>();
	formattedSubject = computed(() => replaceDashWithSpace(this.subject()));

	subtitle = computed(() => {
		const clearingStartDate = this._clearingSrv.getStartDateString();
		return `Clearing starts on ${clearingStartDate}`;
	});

	description = computed(() => this._getHeaderDescription());

	currentYear = new Date().getFullYear();

	private _metadataEffect = effect(() => {
		const clearingStartDate = this._clearingSrv.getStartDateString();

		const title = formatClearingTitle(
			CLEARING_DISABLED_COPY.meta_title,
			this.subject(),
			this.currentYear,
		);
		const description = formatClearingDisabledDesc(
			CLEARING_DISABLED_COPY.meta_desc,
			this.subject(),
			clearingStartDate,
		);

		this._seoSrv.updateTitle(title);
		this._seoSrv.updateDescription(description);
	});

	constructor(
		public _clearingSrv: ClearingService,
		private _seoSrv: SeoMetadataService,
	) {}

	ngOnDestroy() {
		this._metadataEffect.destroy();
	}

	private _getHeaderDescription() {
		const isPreClearing = this._clearingSrv.isPreClearing();
		const clearingStartDate = this._clearingSrv.getStartDateString();
		const postClearingDate = clearingStartDate.replace(
			this.currentYear.toString(),
			`${this.currentYear + 1}`,
		);

		const { header_desc_pre_clearing, header_desc_post_clearing } =
			CLEARING_DISABLED_COPY;

		const copy = isPreClearing ? header_desc_pre_clearing : header_desc_post_clearing;
		const date = isPreClearing ? clearingStartDate : postClearingDate;

		return formatClearingDisabledDesc(copy, this.subject(), date);
	}
}
